export enum TableRole {
    Table = 'table',
    Body = 'tableBody',
    Row = 'tableRow',
    Cell = 'tableCell',
}
